var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[_c('img',{staticClass:"image",attrs:{"src":_vm.avatar}}),_c('span',{staticClass:"nickname"},[_vm._v(_vm._s(_vm.nickname))]),_c('span',{staticClass:"description"},[_vm._v(_vm._s(_vm.description))])])}
var staticRenderFns = []

export { render, staticRenderFns }